import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface IImeiStepService {
  validateImei(imei: string, idTrade: string): Observable<any>;
  confirmImei(imei: string, idTrade: string): Observable<any>;
}

export const IMEI_STEP_SERVICE = new InjectionToken<IImeiStepService>('IMEI_STEP_SERVICE');
